import { ReactNode, MouseEvent } from "react"

type EditorToolbarActionProps = {
  icon: ReactNode
  label: string
  text: string
  onClick: () => void
  disabled?: boolean
  isActive?: boolean
}

const EditorToolbarAction = ({
  icon,
  label,
  text,
  onClick,
  disabled = false,
  isActive = false,
}: EditorToolbarActionProps) => {
  const handleMouseDown = (event: MouseEvent<HTMLButtonElement>) => {
    // Keep editor selection (needed for table row/column commands).
    event.preventDefault()
  }

  return (
    <button
      type='button'
      className={`tiptap-editor__toolbar-action${isActive ? " is-active" : ""}`}
      onMouseDown={handleMouseDown}
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      title={label}
    >
      <span className='tiptap-editor__toolbar-action-icon'>{icon}</span>
      <span className='tiptap-editor__toolbar-action-text'>{text}</span>
    </button>
  )
}

export default EditorToolbarAction
